import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import styled from 'styled-components';

const QandAStyles = styled.section`
  .Collapsible {
    padding: 20px 0;
    border-top: 2px solid ${props => props.theme.gray200};
    transition: all 0.2s;
    &__trigger {
      text-transform: uppercase;
      font-weight: 700;
      display: block;
      padding: 4px 0;
      cursor: pointer;
      position: relative;
      padding-right: 30px;
      &::after {
        content: '+';
        position: absolute;
        right: 0;
        top: 0;
        color: ${props => props.theme.primary};
        font-size: 1.5rem;
        font-weight: 700;
        transition: all 0.3s;
        line-height: 1;
      }
      &.is-open {
        &::after {
          transform: rotate(135deg);
          color: #e91e63;
        }
      }
    }
    &__contentInner {
      padding: 10px 30px 10px 0;
      font-size: 1rem;
    }
  }
`;

class QandAComponent extends Component {
  showTitle() {
    if (this.props.title) {
      return <h1>{this.props.title}</h1>;
    }
    return '';
  }

  render() {
    return (
      <QandAStyles>
        <div className="container">
          {this.showTitle()}
          {this.props.data.map(qa => (
            <Collapsible trigger={qa.question} easing="ease-in-out" key={qa.question}>
              <div dangerouslySetInnerHTML={{ __html: qa.answer }} />
            </Collapsible>
          ))}
        </div>
      </QandAStyles>
    );
  }
}

export default QandAComponent;
